<template>
<div>
    <b-container class="px-0">
        <b-row class="justify-content-md-center">
            <b-col cols=12>
                <b-card no-body tag="h1" class="border-0 pt-3 pb-3 bg-transparent">{{pag.nume | fixTitlu }}
                </b-card>
            </b-col>
        </b-row>

        <b-row id="catalogopac" class="justify-md-content-center text-center">
            <b-col cols=12>
                <b-form>
                    <b-input id="search_form" placeholder="Cauta un articol..." v-model="searchQuery"></b-input>
                    <b-button variant="primary" class="my-4 px-4" @click="submitSearch">Caută</b-button>
                </b-form>
            </b-col>
        </b-row>

        <b-row class="justify-content-md-center" v-if="fara_rezultat">
            <b-col cols="12" md="6" xl="4" class="mb-4">
                
                <b-card
                    tag="article"
                    class="shadow p-0 mb-4 rounded bg-transparent"
                    fluid>
                    <b-card-title title-tag="h3" >Nu s-a găsit niciun rezultat!</b-card-title>
                    <div class="d-flex justify-content-center">
                        <b-button squared variant="primary" class="px-4 my-2 btn-index-card" v-on:click="revino">
                            Revino la pagina inițială
                        </b-button>
                    </div>
                </b-card>
            </b-col>
        </b-row>

        <b-row class="justify-content-md-center">
            <b-col cols="12" md="6" xl="4" class="mb-4" v-for="l in list" :key="l.id">
                <b-card :img-src="l.uagb_featured_image_src.full === false ? require('../assets/imgplacehold.png') : l.uagb_featured_image_src.full[0]" img-alt="Biblioteca Județeană Arad" img-top tag="article" class="shadow p-0 mb-4 rounded bg-transparent" fluid>
                    <b-card-title title-tag="h4" v-html="l.title.rendered"></b-card-title>
                    <b-card-text v-html="l.uagb_excerpt"></b-card-text>
                    <div class="d-flex justify-content-center">
                        <b-button squared variant="primary" class="px-4 my-2 btn-index-card">
                            <router-link :to="{ path: '/articol/'+ l.id}">Citește articolul</router-link>
                        </b-button>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </b-container>

    <infinite-loading @infinite="infiniteHandler">
        <div slot="spinner">Se încarcă...</div>
        <div slot="no-more">Listă de articole epuizată.</div>
        <div slot="no-results">Fără rezultate.</div>
    </infinite-loading>
</div>
</template>

<script>
export default {
    data() {
        return {
            page: 1,
            list: [],
            infiniteId: +new Date(),
            eroare: '',
            pag: this.$route.params,
            isResult: false,
            searchQuery: '',
            searchData: '',
            fara_rezultat : false
        };
    },
    created() {

    },
    filters: {
        fixTitlu: function (value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1).replace('-', ' ');
        }
    },
    methods: {
        removeSearchQuery: function () {
            this.searchQuery = '';
            this.isResult = false;
        },
        submitSearch: function () {
            var reqURL = 'https://bibliotecaarad.ro/wp-json/wp/v2/posts?categories=' + this.$route.params.id + '&search=' + this.searchQuery + '&per_page=12';
            fetch(reqURL)
                .then(response => response.json())
                .then(data => {
                    this.list = '';
                    this.list = data;
                      if(data.length == 0) {
                        //alert('Nu exista rezultate!');
                        this.list = [];
                        this.fara_rezultat = true;
                    }
                });

        },
        revino: function() {
            this.fara_rezultat = false;
            this.searchQuery = '';
            window.location.reload()
        },
        infiniteHandler($state) {

            const api = 'https://bibliotecaarad.ro/wp-json/wp/v2/posts?per_page=12&orderby=date&order=desc&categories=' + this.$route.params.id + '&page=' + this.page + '&per_page=12';

            if (this.searchQuery.length > 1) {
                this.api = 'https://bibliotecaarad.ro/wp-json/wp/v2/posts?search=' + this.searchQuery + '&categories=' + this.$route.params.id + '&page=' + this.page + '&per_page=12';
            }

            fetch(api)
                .then(response => response.json())
                .then(data => {
                    if (data.length) {
                        this.page += 1;
                        this.list.push(...data);
                        $state.loaded();
                    } else {
                        $state.complete();
                    }
                }).catch(error => {
                    $state.complete();
                    this.eroare = error.response;
                });
        },
        changeType() {
            this.page = 1;
            this.list = [];
            this.infiniteId += 1;
        },
    },
};
</script>
